import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierPettyCashBudgetAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as pettyCashBudgetApi from "../../api/pettyCashBudget/pettyCashierPettyCashBudget";
import { GetAccountTitlesFilter } from "../../containers/pettyCashBudget/filter";
import { SetMessage } from "../../assets/errorMessages";

export function* pettyCashierWatcherPettyCashBudget() {
  yield takeLatest(
    types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_REQUEST,
    workerShow
  );
  yield takeLatest(
    types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_REQUEST,
    workerShowByAccountTitles
  );
}

async function fetchShow(id) {
  return pettyCashBudgetApi.show(id);
}

function* workerShow(action) {
  try {
    const response = yield call(fetchShow, action.id);
    yield put(PettyCashierPettyCashBudgetAction.showSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierPettyCashBudgetAction.showFailure(message));
  }
}

async function fetchShowByAccountTitles(imprest_id) {
  return pettyCashBudgetApi.showByAccountTitles(
    GetAccountTitlesFilter(imprest_id)
  );
}

function* workerShowByAccountTitles(action) {
  try {
    const response = yield call(fetchShowByAccountTitles, action.imprestId);
    yield put(
      PettyCashierPettyCashBudgetAction.showByAccountTitlesSuccess(
        response.data.data
      )
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(
      PettyCashierPettyCashBudgetAction.showByAccountTitlesFailure(message)
    );
  }
}
